export default __webpack_public_path__ + "static/media/cloud.921265c5.webp";